import { Licenses } from "@nova/constants"
import classNames from "classnames"
import React, { FunctionComponent } from "react"

interface LicenseBadgeProps {
    license: Licenses
}

const licenseBadgeStyles: Record<Licenses, string> = {
    pro: "bg-[linear-gradient(180deg,#807600_0%,#FFEA00_100%)] text-white",
    essentials: "bg-[linear-gradient(180deg,#EFF2F8_0%,#4F545E_100%)] text-white",
    lite: "bg-[linear-gradient(180deg,#BC712F_0%,#442B16_100%)] text-white",
}

const LicenseBadge: FunctionComponent<LicenseBadgeProps> = ({ license }) => {
    return (
        <small
            className={classNames(
                "flex items-center relative px-1.5 py-0.5 rounded-md telegraf w-fit inline-block align-top leading-none text-xs overflow-hidden",
                licenseBadgeStyles[license]
            )}
        >
            <span
                className="absolute inset-[1px] rounded-[5px] bg-[#1a1a1a] z-0"
                aria-hidden="true"
            />
            <span className="relative z-10">
                {license.charAt(0).toUpperCase() + license.slice(1)}
            </span>
        </small>
    )
}

export { LicenseBadge }
